jQuery(document).ready(function ($) {
        
    $('.moreless-button').click(function() {
	  $('.product__description.rte').toggleClass('ellipses');
	  if ($('.moreless-button').text() == "Read More About Product") {
		$(this).text("Read Less")
	  } else {
		$(this).text("Read More About Product")
	  }
	});

    $('.readmore-button').click(function() {
	  $('.brand.rte').toggleClass('ellipses');
	  if ($('.readmore-button').text() == "Read More About Brand") {
		$(this).text("Read Less")
	  } else {
		$(this).text("Read More About Brand")
	  }
	});
        
});